module.exports = __webpack_public_path__ + "img/stock4.c412c2b2.png";